// gradientFor.js — supports named themes + direct hex colors

// 12-pack + zynity + default
const THEMES = {
  // Zynity core & default
  zynity:   { from: '#00d2ff', to: '#0096ff', text: '#fff' }, // Sync→Initiate
  default:  { from: '#0b5bd6', to: '#014bb3', text: '#fff' }, // darker right end

  // Extended themes
  ocean:    { from: '#0072ff', to: '#00c6ff', text: '#fff' },
  forest:   { from: '#43e97b', to: '#38f9d7', text: '#0b3b2e' },
  coral:    { from: '#ff6a00', to: '#ee0979', text: '#fff' },
  amber:    { from: '#f7971e', to: '#ffd200', text: '#4a3500' },
  plum:     { from: '#7f00ff', to: '#e100ff', text: '#fff' },
  steel:    { from: '#606c88', to: '#3f4c6b', text: '#fff' },
  sky:      { from: '#36d1dc', to: '#5b86e5', text: '#05304a' },
  rose:     { from: '#f953c6', to: '#b91d73', text: '#fff' },
  charcoal: { from: '#232526', to: '#414345', text: '#fff' },
  mint:     { from: '#76b852', to: '#8DC26F', text: '#0b3b1a' },
  indigo:   { from: '#4776E6', to: '#8E54E9', text: '#fff' },
  lava:     { from: '#ff512f', to: '#dd2476', text: '#fff' },
};

// --- helpers ---
const HEX_RE = /^#([A-Fa-f0-9]{6}|[A-Fa-f0-9]{3})$/;

function hexToRgb(hex) {
  let h = hex.replace('#', '');
  if (h.length === 3) h = h.split('').map(c => c + c).join('');
  const num = parseInt(h, 16);
  return { r: (num >> 16) & 255, g: (num >> 8) & 255, b: num & 255 };
}

function rgbToHex(r, g, b) {
  return (
    '#' +
    [r, g, b]
      .map(v => {
        const s = v.toString(16);
        return s.length === 1 ? '0' + s : s;
      })
      .join('')
  );
}

function darken(hex, amount = 20) {
  const { r, g, b } = hexToRgb(hex);
  const f = (v) => Math.max(0, Math.min(255, Math.round(v * (1 - amount / 100))));
  return rgbToHex(f(r), f(g), f(b));
}

function readableText(hex) {
  const { r, g, b } = hexToRgb(hex);
  // YIQ contrast
  const yiq = (r * 299 + g * 587 + b * 114) / 1000;
  return yiq >= 140 ? '#0d0d0d' : '#fff';
}

// --- main ---
export const gradientFor = (key) => {
  const k = (key || 'default').toString().trim().toLowerCase();

  // Named theme?
  if (THEMES[k]) return THEMES[k];

  // Direct HEX? build gradient from hex → darker(hex)
  if (HEX_RE.test(k)) {
    const from = k;
    const to = darken(k, 18);
    return { from, to, text: readableText(from) };
  }

  // Fallback
  return THEMES.default;
};
